export type AuthModalIntent = 'sign_in' | 'paid_content';

export type AuthModalEventDetail =
    | { action: 'open'; intent: AuthModalIntent; redirectUrl?: string }
    | { action: 'close' };

export const AUTH_MODAL_EVENT = 'auth-modal';

export const openAuthModal = (intent: AuthModalIntent, redirectUrl?: string) => {
    window.dispatchEvent(new CustomEvent<AuthModalEventDetail>(AUTH_MODAL_EVENT, {
        detail: { action: 'open', intent, redirectUrl }
    }));
};

export const closeAuthModal = () => {
    window.dispatchEvent(new CustomEvent<AuthModalEventDetail>(AUTH_MODAL_EVENT, {
        detail: { action: 'close' }
    }));
};
